"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    camelCaseToUnderscore: function (string) {
        return string.replace(/\.?([A-Z])/g, function (x, y) { return "_" + y.toLowerCase(); });
    },
    underscoreToCamelCase: function (string) {
        return string.replace(/_([a-z])/g, function (g) { return g[1].toUpperCase(); });
    },
};
//# sourceMappingURL=string_util.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/reverb-js-common/string_util.js
// module id = st2T
// module chunks = 20 21 22